import { render, staticRenderFns } from "./headers-header-search.vue?vue&type=template&id=3990b210&scoped=true&"
import script from "./headers-header-search.vue?vue&type=script&lang=js&"
export * from "./headers-header-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3990b210",
  null
  
)

export default component.exports